import { defineMessages } from 'react-intl'

export default defineMessages({
  add: {
    id: 'Add',
    defaultMessage: 'Add'
  },
  cancel: {
    id: 'Cancel',
    defaultMessage: 'Cancel'
  },
  name: {
    id: 'SpaceSurveyPage.Results.Title',
    defaultMessage: 'Survey and Polling Manager'
  },
  back: {
    id: 'Back',
    defaultMessage: 'back'
  },
  updatingMember: {
    id: 'SpaceMemberEditPage.UpdatingMember',
    defaultMessage: 'Updating Member'
  },
  addUserTitle: {
    id: 'SpaceMemberEditPage.AddTitle',
    defaultMessage: 'Add Space Member'
  },
  editUserTitle: {
    id: 'SpaceMemberEditPage.EditTitle',
    defaultMessage: 'Edit Space Member'
  },
  givenName: {
    id: 'SpaceMemberEditPage.FirstName',
    defaultMessage: 'First Name'
  },
  familyName: {
    id: 'SpaceMemberEditPage.LastName',
    defaultMessage: 'Last Name'
  },
  displayName: {
    id: 'SpaceMemberEditPage.DisplayName',
    defaultMessage: 'Display Name'
  },
  externalId: {
    id: 'SpaceMemberEditPage.ExternalId',
    defaultMessage: 'External ID'
  },
  email: {
    id: 'SpaceMemberEditPage.Email',
    defaultMessage: 'Email'
  },
  spaceRoles: {
    id: 'SpaceMemberEditPage.SpaceRoles',
    defaultMessage: 'Space Roles'
  },
  title: {
    id: 'Update',
    defaultMessage: 'Update'
  },
  update: {
    id: 'Update',
    defaultMessage: 'Update'
  },
  logOutAfterUpdate: {
    id: 'SpaceMemberEditPage.LogOutAfterUpdate',
    defaultMessage: 'To fully apply new roles to your account, you will need to log out after updating.'
  },
  updatingLoggedInUser: {
    id: 'SpaceMemberEditPage.UpdatingLoggedInUser',
    defaultMessage:
      'Updating your account. Changes may take up to 5 minutes to take effect, and require logging out and back in.'
  }
})
